import { objToQs } from "../Utils";

import Call from '../Call.v3';

const BidderRealtime = {
    hourly: {
        get: ({ groupBy, source, country }) => Call(`wbidder/realtime/hourly?${objToQs({ groupBy, source, country })}`)
    },
    daily: {
        get: ({ groupBy, source, country }) => Call(`wbidder/realtime/daily?${objToQs({ groupBy, source, country })}`)
    }
};

export default BidderRealtime;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderRealtime.js